export default __webpack_public_path__ + "static/media/icon-2.309eed84.svg";